import React, { useState } from 'react'
import TemporaryAccessModal from './TemporaryAccessModal'
import { CheckCircle } from '@phosphor-icons/react'
import UbiquaTowerToastAlert from '../../../components/alerts/UbiquaTowerToastAlert'
import { getTemporaryAccessContent } from '../../constants/temporaryAccessConstants'
import { UI_COLOR_SUCCESS_SOFT, UI_COLOR_SUCCESS_TEXT } from '../../../constants/uiColors'

const TemporaryAccessSuccessModal = ({ action = 'create', access, onAccessClose, onComplete }) => {
  const [open, setOpen] = useState(true)
  const [showAlert, setShowAlert] = useState(false)
  const [userUid, setUserUid] = useState(null)
  const messages = getTemporaryAccessContent(action)

  const closeAccess = () => {
    setUserUid(access.uid)
    setOpen(false)
    setShowAlert(true)
    onAccessClose?.()
  }

  const closeAlert = () => {
    setShowAlert(false)
    onComplete?.(userUid)
  }

  return (
    <>
      {open && access?.temporary_password && (
        <TemporaryAccessModal
          access={access}
          title={messages.modalTitle}
          variant={messages.variant}
          onClose={closeAccess}
        />
      )}
      <UbiquaTowerToastAlert
        open={showAlert}
        title={messages.alertTitle}
        message={messages.message}
        icon={<CheckCircle size={18} aria-hidden="true" />}
        colors={{ iconBackground: UI_COLOR_SUCCESS_SOFT, progress: UI_COLOR_SUCCESS_TEXT }}
        onClose={closeAlert}
      />
    </>
  )
}
export default TemporaryAccessSuccessModal
